import React, { useEffect } from 'react';
import Helmet from 'react-helmet';
import parse from 'html-react-parser';
import Text from 'components/Core/Text';
import { reduceContentValues } from 'utils/text';
import { EmbedContainer } from '../RichTextEmbed/styles';

const RichTextParagraphBlock = ({ children, node, size, bareOptions, ...otherProps }) => {
  const contentString = reduceContentValues(node?.content) || '';
  const paragraphText =
    children && Array.isArray(children) && children.join().startsWith('<')
      ? parse(children.join())
      : children;

  useEffect(() => {
    if (contentString.includes('<script')) {
      const js = contentString.substr(
        contentString.indexOf('<script>') + 8,
        contentString.indexOf('</script>') - 8,
      );
      try {
        new Function(js)();
      } catch (err) {
        console.log('Innerhtml Javascript script code contained an error:', err);
      }
    }
  }, []);

  if (contentString.includes('<iframe') || contentString.includes('<div')) {
    const contentHtml = reduceContentValues(node?.content) || '';
    return <EmbedContainer {...otherProps} dangerouslySetInnerHTML={{ __html: contentHtml }} />;
  }
  if (contentString.includes('<script') || contentString.includes('<link')) {
    const contentHtml = reduceContentValues(node?.content) || '';
    return <Helmet {...otherProps}>{parse(contentHtml)}</Helmet>;
  }
  return bareOptions ? (
    paragraphText
  ) : (
    <Text type={size === 'overline' ? 'overline' : 'p'} size={size} {...otherProps}>
      {children && Array.isArray(children) && children.join().startsWith('<')
        ? parse(children.join())
        : children}
    </Text>
  );
};

export default RichTextParagraphBlock;
